import { GlobalAxios } from "../axios/axios-config";
import {
  IListTemplateGeneral,
  INewTemplateGeneral,
  ITemplateGenerals,
} from "../models/template-general";

const SALES_CONTRACT_PRICE_LIST_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TemplateGeneral/";

export const createTemplateGeneral = (item: INewTemplateGeneral) => {
  return GlobalAxios.post(SALES_CONTRACT_PRICE_LIST_ROUTE, item);
};

export const getTemplateGeneralById = (id: string) => {
  return GlobalAxios.get<ITemplateGenerals>(
    SALES_CONTRACT_PRICE_LIST_ROUTE + id,
  );
};

export const updateTemplateGeneralById = ({
  item,
  id,
}: {
  item: INewTemplateGeneral;
  id: string;
}) => {
  return GlobalAxios.put(SALES_CONTRACT_PRICE_LIST_ROUTE + id, item);
};

export const listTemplateGeneral = (params?: any) => {
  return GlobalAxios.get<IListTemplateGeneral[]>(
    SALES_CONTRACT_PRICE_LIST_ROUTE + "list",
    {
      params: params,
    },
  );
};

export const approveSalesContractPriceList = (id: string) => {
  return GlobalAxios.put(
    `${SALES_CONTRACT_PRICE_LIST_ROUTE}ApprovalDate/${id}`,
  );
};
